// ============================================================
// DADOS DA OPERAÇÃO — fonte única de verdade do conteúdo factual
// ------------------------------------------------------------
// REGRA (DESIGN.md): nada aqui pode ser número inventado. Enquanto a
// empresa não tiver histórico auditável, usamos afirmação de PROCESSO
// (janela de coleta, área de atuação, política de acompanhamento), que
// é verdade desde o primeiro dia — nunca "98% no prazo" ou "5.000 entregas".
//
// Vale também para conformidade: falamos do que EXIGIMOS da operação
// (habilitação do motorista, documentação da carga, enquadramento prévio),
// nunca de certificação ou selo que a empresa não tenha comprovado.
//
// Quando o Leonardo passar números reais medidos, entram aqui.
// ============================================================

export const OPERACAO = {
  desde: 2017,
  janelaColeta: 'Mesmo dia',
  limitePedido: '16h',
  base: 'São Paulo / SP',
  areaAtuacao: 'Grande São Paulo',
  atendimento: 'Seg–Sex · 9h–18h',
}

// Municípios onde a operação atua. Sem prazo por cidade — prazo depende de
// rota, horário e trânsito, e prometer minuto por município seria chute.
export const COBERTURA = [
  { nome: 'São Paulo', nota: 'base' },
  { nome: 'Guarulhos' },
  { nome: 'Osasco' },
  { nome: 'Barueri' },
  { nome: 'Santo André' },
  { nome: 'São Bernardo do Campo' },
  { nome: 'São Caetano do Sul' },
  { nome: 'Diadema' },
  { nome: 'Mauá' },
  { nome: 'Ribeirão Pires' },
  { nome: 'Itaquaquecetuba' },
  { nome: 'Suzano' },
  { nome: 'Mogi das Cruzes' },
  { nome: 'Carapicuíba' },
  { nome: 'Taboão da Serra' },
  { nome: 'Cotia' },
]

export const SERVICOS = [
  {
    cod: '01',
    titulo: 'Carga fracionada',
    desc: 'Volumes que não ocupam o veículo inteiro, consolidados por rota. Indicado para reposição de estoque, entrega a lojas e envio recorrente de pedidos.',
    itens: ['Coleta no endereço de origem', 'Consolidação por região', 'Comprovante de entrega'],
  },
  {
    cod: '02',
    titulo: 'Carga dedicada',
    desc: 'Veículo exclusivo para a sua carga, do embarque à entrega, sem parada intermediária. Para volume alto, prazo curto ou mercadoria que não pode ser transbordada.',
    itens: ['Veículo exclusivo', 'Rota direta', 'Motorista identificado'],
  },
  {
    cod: '03',
    titulo: 'Produtos perigosos',
    desc: 'A atividade registrada da empresa, e o embarque que a maior parte das transportadoras não aceita. Carga classificada e rotulada, com a documentação exigida, motorista habilitado e veículo compatível com a classe de risco.',
    itens: ['Enquadramento antes da coleta', 'Documentação e ficha de emergência', 'Motorista com curso obrigatório'],
  },
  {
    cod: '04',
    titulo: 'Coleta programada',
    desc: 'Roteiro fixo em dias e horários combinados, para quem despacha com frequência. Reduz a negociação a cada envio e estabiliza o custo do transporte.',
    itens: ['Dias e horários fixos', 'Condição comercial acordada', 'Contato direto'],
  },
]

export const PASSOS = [
  { n: '01', titulo: 'Você descreve a carga', desc: 'Origem, destino e o que vai ser transportado. Se for produto perigoso, também a classe de risco e o número ONU que constam na nota.' },
  { n: '02', titulo: 'Confirmamos e fechamos o valor', desc: 'Verificamos qual veículo a carga exige e retornamos com o valor fechado e a janela de coleta, antes de qualquer deslocamento.' },
  { n: '03', titulo: 'Alocamos veículo e motorista', desc: 'A carga é atribuída ao veículo e ao motorista adequados ao peso, à rota e ao tipo de mercadoria.' },
  { n: '04', titulo: 'Você acompanha até a entrega', desc: 'Um código de acompanhamento é emitido no embarque e a entrega é confirmada com comprovante.' },
]

// Afirmações de processo — verdadeiras desde o dia 1, sem métrica inventada.
export const COMPROMISSOS = [
  {
    titulo: 'Valor fechado antes de rodar',
    desc: 'O preço é combinado antes da coleta e não muda depois, salvo alteração pedida por você durante a execução.',
  },
  {
    titulo: 'O que não dá, a gente diz na hora',
    desc: 'A viabilidade da carga é conferida antes de aceitar o pedido — e produto perigoso só embarca classificado, com documentação e veículo compatíveis. Você não descobre um impedimento no meio do caminho.',
  },
  {
    titulo: 'Responsabilidade sobre a mercadoria',
    desc: 'A carga fica sob responsabilidade da Flor de Goiás do embarque até a confirmação de entrega — não é repassada e esquecida.',
  },
  {
    titulo: 'Falando com quem opera',
    desc: 'Atendimento direto com quem coordena a operação. Sem central de atendimento, sem número de protocolo.',
  },
]

export const RESTRICOES = 'Não realizamos mudanças residenciais. Produto perigoso exige enquadramento prévio — classe de risco, número ONU e quantidade informados no pedido.'
